// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConversationReactController from "./conversation_react_controller"
application.register("conversation-react", ConversationReactController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EnvironmentController from "./environment_controller"
application.register("environment", EnvironmentController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImportIntentsController from "./import_intents_controller"
application.register("import-intents", ImportIntentsController)

import IntentFormController from "./intent_form_controller"
application.register("intent-form", IntentFormController)

import IntentModalController from "./intent_modal_controller"
application.register("intent-modal", IntentModalController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ResponseTimeChartController from "./response_time_chart_controller"
application.register("response-time-chart", ResponseTimeChartController)

import ScenarioCollectionController from "./scenario_collection_controller"
application.register("scenario-collection", ScenarioCollectionController)

import ScenarioFormController from "./scenario_form_controller"
application.register("scenario-form", ScenarioFormController)

import ScenarioGenerationController from "./scenario_generation_controller"
application.register("scenario-generation", ScenarioGenerationController)

import ScenarioImportController from "./scenario_import_controller"
application.register("scenario-import", ScenarioImportController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)
